export default __webpack_public_path__ + "static/media/csv.dbf3843c.svg";